import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import DashboardPage from './pages/DashboardPage'
import BasicMatchPage from './pages/BasicMatchPage'
import MatchResultPage from './pages/MatchResultPage'
import PrecisionMatchPage from './pages/PrecisionMatchPage'
import ReportPage from './pages/ReportPage'
import PackagesPage from './pages/PackagesPage'
import ResumeOptimizePage from './pages/ResumeOptimizePage'
import InterviewPage from './pages/InterviewPage'
import IntelligencePage from './pages/IntelligencePage'
import PaymentPage from './pages/PaymentPage'
import SharePage from './pages/SharePage'
import JobsPage from './pages/JobsPage'
import PrivacyPage from './pages/PrivacyPage'
import NotFoundPage from './pages/NotFoundPage'
import AdminLoginPage from './pages/admin/AdminLoginPage'
import AdminDashboardPage from './pages/admin/AdminDashboardPage'
import AdminTagsPage from './pages/admin/AdminTagsPage'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="match" element={<BasicMatchPage />} />
        <Route path="match-result" element={<MatchResultPage />} />
        <Route path="precision" element={<PrecisionMatchPage />} />
        <Route path="report" element={<ReportPage />} />
        <Route path="packages" element={<PackagesPage />} />
        <Route path="resume" element={<ResumeOptimizePage />} />
        <Route path="interview" element={<InterviewPage />} />
        <Route path="intelligence" element={<IntelligencePage />} />
        <Route path="payment" element={<PaymentPage />} />
        <Route path="share" element={<SharePage />} />
        <Route path="jobs" element={<JobsPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
      <Route path="/admin/tags" element={<AdminTagsPage />} />
    </Routes>
  )
}

export default App
